import React, {useEffect, useState} from 'react';

import {SampleStatusItem} from 'constants/SampleStatusConstants';
import {
  getRestrictionStatusText,
  queryForItemSampleSupport,
} from 'inventory/sample-status/SampleStatusPresentationUtils';

interface SampleRestrictionStatusLabelProps {
  item: SampleStatusItem;
  itemSupportsSampleStatus: boolean;
}

export function SampleRestrictionStatusLabel(props: SampleRestrictionStatusLabelProps): JSX.Element {
  return <span>{getRestrictionStatusText(props.item, props.itemSupportsSampleStatus)}</span>;
}

export function QueryingSampleRestrictionStatusLabel(
  props: Omit<SampleRestrictionStatusLabelProps, 'itemSupportsSampleStatus'>
): JSX.Element {
  const [supportsSampleRestrictionStatus, setSupportsSampleRestrictionStatus] = useState<boolean>(false);

  useEffect(() => {
    const getSupportsSampleStatus = async (): Promise<void> => {
      const itemSupportsSampleStatus = await queryForItemSampleSupport(props.item.id);
      setSupportsSampleRestrictionStatus(itemSupportsSampleStatus);
    };

    getSupportsSampleStatus();
  });

  return (
    <SampleRestrictionStatusLabel
      item={props.item}
      itemSupportsSampleStatus={supportsSampleRestrictionStatus}
    />
  );
}
